import { C } from "@/brand/tokens";
import { finalCta6, brand6 } from "@/brand/contentF6";
import { Box6 } from "@/components/common/Box6";
import { Eyebrow6 } from "@/components/common/Eyebrow6";
import { Cta6 } from "@/components/common/Cta6";

/** FinalCtaSection6 — closing invitation on Deep Mineral Blue. */
export function FinalCtaSection6() {
  return (
    <section id="final-cta" data-testid="final-cta-6" style={{ background: C.surfacePrimary, color: C.textOnDark }}>
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10 py-20 lg:py-24">
        <Box6 tone="glass" radius="card" className="p-10 lg:p-16 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <Eyebrow6 className="mb-6">{finalCta6.eyebrow}</Eyebrow6>
            <h2
              className="font-cormorant"
              style={{ color: C.textOnDark, fontSize: "clamp(2rem, 4vw, 3.2rem)", fontWeight: 400, lineHeight: 1.06, letterSpacing: "-0.012em" }}
            >
              {finalCta6.headline}
            </h2>
            <p className="mt-6 font-inter leading-[1.7] max-w-[56ch]" style={{ color: C.whiteOnDark, fontSize: "1rem" }}>
              {finalCta6.body}
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-4">
            <Cta6 to={finalCta6.primaryCta.href} variant="light" testId="final-cta-primary" className="justify-between px-6 py-4">
              {finalCta6.primaryCta.label}
            </Cta6>
            <Cta6 href={`mailto:${brand6.email}`} variant="outlineLight" testId="final-cta-secondary" className="justify-between px-6 py-4">
              {finalCta6.secondaryLabel}
            </Cta6>
          </div>
        </Box6>
      </div>
    </section>
  );
}
